<div class="section-header">
    <div class="title">
        Verbrauchsmaterialbezug
    </div>
</div>

<div class="table">
    <div class="field-row">
        <div class="label-cell">Ausgewählt</div>
        <div class="field-content">{{ getShoppingModeDescription() }}</div>
    </div>

    <ng-container *ngIf="isSupplyOrderActive()">
        <div class="field-row">
            <div class="label-cell">Bezug über:</div>
            <div class="field-content distributor-name" [innerHTML]="getCurrentSupplyDistributorName()"></div>
        </div>

        <div class="field-row" *ngIf="isSecondaryDistributorVisible()">
            <div class="label-cell">Bezug alternativ über:</div>
            <div class="field-content distributor-name" [innerHTML]="getCurrentSecondarySupplyDistributorName()"></div>
        </div>
        <div class="field-row">
            <div class="label-cell">Bezugsbeginn:</div>
            <div class="field-content"
                 *ngIf="model.project.requestedSupplyInfo?.rolloutStart">{{ model.project.requestedSupplyInfo.rolloutStart  | date:'dd.MM.yyyy' }}</div>
            <div class="field-content" *ngIf="!model.project.requestedSupplyInfo?.rolloutStart">-</div>
        </div>

        <div class="field-row" *ngIf="!isPrintSmartSupplyAcquisitionType()">
            <div class="label-cell">Bezugsende:</div>
            <div class="field-content"
                 *ngIf="model.project.requestedSupplyInfo?.rolloutEnd">{{ model.project.requestedSupplyInfo.rolloutEnd | date:'dd.MM.yyyy'}}</div>
            <div class="field-content" *ngIf="!model.project.requestedSupplyInfo?.rolloutEnd">-</div>
        </div>

        <div class="field-row" *ngIf="isPrintSmartSupplyAcquisitionType()">
            <div class="label-cell">Laufzeit:</div>
            <div class="field-content">
                {{ model.project.requestedSupplyInfo?.timePeriodInMonths }}
                {{ model.project.requestedSupplyInfo?.timePeriodInMonths || model.project.requestedSupplyInfo?.timePeriodInMonths === 0 ? 'Monate' : '-'}}
            </div>
        </div>

    </ng-container>


</div>

